import React, { useState } from "react";
import NavbarContainer from "./NavbarContainer";
import { Link } from "./../util/router.js";
import { useAuth } from "./../util/auth.js";

function Navbar(props) {
  const auth = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <NavbarContainer>
      <ul id="primary-nav" class="main-nav nav align-items-lg-stretch justify-content-center" data-submenu-options='{ "toggleType":"fade", "handler":"mouse-in-out" }' data-localscroll="true">
          <li>
              <a href="/">
                  <span class="link-icon"></span>
                  <span class="link-txt">
                      <span class="link-ext"></span>
                      <span class="txt">
                          Home
                          <span class="submenu-expander">
                              <i class="fa fa-angle-down"></i>
                          </span>
                      </span>
                  </span>
              </a>
          </li>
          <li>
              <a href="#about">
                  <span class="link-icon"></span>
                  <span class="link-txt">
                      <span class="link-ext"></span>
                      <span class="txt">
                          About
                          <span class="submenu-expander">
                              <i class="fa fa-angle-down"></i>
                          </span>
                      </span>
                  </span>
              </a>
          </li>
          <li>
              <a href="#smm-services">
                  <span class="link-icon"></span>
                  <span class="link-txt">
                      <span class="link-ext"></span>
                      <span class="txt">
                          Services
                          <span class="submenu-expander">
                              <i class="fa fa-angle-down"></i>
                          </span>
                      </span>
                  </span>
              </a>
          </li>
          <li>
              <a href="#our-portfolio">
                  <span class="link-icon"></span>
                  <span class="link-txt">
                      <span class="link-ext"></span>
                      <span class="txt">
                          Portfolio
                          <span class="submenu-expander">
                              <i class="fa fa-angle-down"></i>
                          </span>
                      </span>
                  </span>
              </a>
          </li>
          <li>
              <a href="#contact-us">
                  <span class="link-icon"></span>
                  <span class="link-txt">
                      <span class="link-ext"></span>
                      <span class="txt">
                          Contact
                          <span class="submenu-expander">
                              <i class="fa fa-angle-down"></i>
                          </span>
                      </span>
                  </span>
              </a>
          </li>
      </ul>
      {/* <div className="container">
        <div className="navbar-brand">
          <div className="navbar-item">
            <Link to="/">
              <img className="image" src={props.logo} alt="Logo" />
            </Link>
          </div>
          <div
            className={"navbar-burger burger" + (menuOpen ? " is-active" : "")}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
        <div className={"navbar-menu" + (menuOpen ? " is-active" : "")}>
          <div className="navbar-end">
            {auth.user && (
              <div className="navbar-item has-dropdown is-hoverable">
                <Link className="navbar-link" to="/">
                  Account
                </Link>
                <div className="navbar-dropdown is-boxed">
                  <Link className="navbar-item" to="/dashboard">
                    Dashboard
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/signout"
                    onClick={e => {
                      e.preventDefault();
                      auth.signout();
                    }}
                  >
                    Sign out
                  </Link>
                </div>
              </div>
            )}

            {!auth.user && (
              <Link className="navbar-item" to="/signin">
                Sign in
              </Link>
            )}
          </div>
        </div>
      </div> */}
    </NavbarContainer>
  );
}

export default Navbar;
